import WRAP from "WRAP-JS";
import { useTimeout } from "../../hooks/useTimeout";
import { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core";
import clsx from "clsx";
import { useMapColorState } from "../../store/MapColorState";

const ZOOM_SCALE = {
  18: 20,
  17: 50,
  16: 100,
  15: 200,
  14: 500,
  13: 1000,
  12: 2000,
  11: 2000,
  10: 10000,
  9: 20000,
  8: 20000,
  7: 50000,
  6: 100000,
  5: 200000,
  4: 500000,
  3: 1000000,
};
const MAX_WIDTH = 84;
const ENABLE_ZOOM = 7;
const MapScaleMeasure = () => {
  const [scaleWidth, setScaleWidth] = useState(0);
  const [scaleLabel, setScaleLabel] = useState('');
  const [hidden, setHidden] = useState(false);
  const {isGoogleMap} = useMapColorState();

  const [changeZoom] = useTimeout(() => {
    if (!WRAP.Geo.view.map.ready()) {
      return;
    }
    const zoom = WRAP.Geo.getZoom();
    if (zoom < ENABLE_ZOOM) {
      setHidden(true);
      return;
    }  else {
      setHidden(false);
    }
    const scale = calcScaleByLat(zoom);
    setScaleWidth(scale.width);
    setScaleLabel(scale.label);

  }, 300);

  useEffect(() => {
    WRAP.Geo.addEventHandler('boundsChange', changeZoom);
    // eslint-disable-next-line
  },[]);

  return (
    <div style={{
      display:'flex',
      zIndex: 2,
      backgroundColor: 'rgba(245, 245, 245, .7)',
      color: '#000',
      padding: 2,
      alignContent: 'center',
      alignItems: 'center',
      columnGap: 2,
      position: 'absolute',
      bottom: isGoogleMap ? 14 : 0,
      right: 135,
    }} hidden={hidden}>
      <div style={{fontSize: 10}}>{scaleLabel}</div>
      <Scale scaleWidth={scaleWidth}/>
    </div>
  )
};

const calcScaleByLat = (zoom) => {
  const centerPoint = WRAP.Geo.getCenterPoint();
  const centerScreen = WRAP.Geo.getScreenPoint(centerPoint);
  let _zoom = Math.floor(zoom);
  let scaleWidth, scaleLabel;
  while (ZOOM_SCALE[_zoom]) {
    const distance = ZOOM_SCALE[_zoom];
    //北
    const distancePoint1 = WRAP.Geo.getGCPoint(centerPoint, distance / 2, 0);
    const distanceScreen1 = WRAP.Geo.getScreenPoint(distancePoint1);
    //南
    const distancePoint2 = WRAP.Geo.getGCPoint(centerPoint, distance / 2, 180);
    const distanceScreen2 = WRAP.Geo.getScreenPoint(distancePoint2);
    //中心座標から南北の距離（スクリーン座標）
    scaleWidth = (centerScreen.y - distanceScreen1.y) + (distanceScreen2.y - centerScreen.y);
    scaleLabel = distance >= 1000 ? `${distance / 1000} km` : `${distance} m`;
    if (scaleWidth <= MAX_WIDTH ) {
      break;
    }
    _zoom++;
  }

  return {
    width: scaleWidth,
    label: scaleLabel
  }
};

const useStyles = makeStyles(() => ({
  root: {
    position: 'relative',
    height: 7,
    willChange: 'contents, width',
    transition: 'all 0.25s'
  },
  edge: {
    width: 0,
    height: 7,
    borderLeft: ' 2px solid #000'
  },
  begin: {
    position: "absolute",
    left: 0
  },
  end: {
    position: 'absolute',
    right: 0
  },
  scale: {
    position: 'absolute',
    bottom: 0,
    width: '100%',
    borderBottom: '2px solid #000'
  },
  // scaleW: {
  //   borderBottom: "2px solid #000",
  //   position: 'relative',
  //   '&:before': {
  //       content: "''",
  //       display: 'block',
  //       width: 0,
  //       height: 5,
  //       borderRight: '2px solid #000',
  //     },
  //   '&:after': {
  //     content: "''",
  //     display: 'block',
  //     position: 'absolute',
  //     right: 0,
  //     top: 0,
  //     width: 0,
  //     height: 5,
  //     borderLeft: '2px solid #000'
  //   }
  // }
}));

const Scale = ({scaleWidth}) => {
  const classes = useStyles();
  return (
    //scaleWidthがedgeのborderの中心からedgeのborderの中心になるようにするため+2
    <div className={classes.root} style={{width: scaleWidth + 2}}>
      <div className={clsx(classes.edge, classes.begin)}/>
      <div className={classes.scale}/>
      <div className={clsx(classes.edge, classes.end)}/>
     </div>
  );
};

export default MapScaleMeasure;
